"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const LogLevelLogger_1 = require("./LogLevelLogger");
class LogLevelLogProvider {
    Init(loglevel) {
        if (!loglevel) {
            console.error("invalid loglevel object");
            return;
        }
        this._loglevel = loglevel;
    }
    GetLogger(loggerName) {
        return new LogLevelLogger_1.LogLevelLogger(loggerName, () => this._loglevel);
    }
}
exports.LogLevelLogProvider = LogLevelLogProvider;
exports.logLevelLogProvider = new LogLevelLogProvider();
//# sourceMappingURL=LogLevelLogProvider.js.map